import React from 'react'
import classNames from 'classnames'

const PaymentMethod = ({ paymentMethod, setPaymentMethod, icon, name, desc, paymentType, hasError }) => {
    return (
        <label
            className={classNames('trip-reservation__payment-method', {
                'trip-reservation__payment-method--error': hasError,
            })}
        >
            <input
                type="radio"
                value={paymentType}
                name="paymentMethod"
                checked={paymentMethod === paymentType}
                onChange={() => setPaymentMethod(paymentType)}
            />
            <span className="trip-reservation__payment-method-radio-checkmark"></span>
            <div className="trip-reservation__payment-method-name">{name}</div>
            <div className="trip-reservation__payment-method-desc">{desc}</div>
            <img
                src={icon}
                alt={paymentMethod}
                className={`trip-reservation__payment-method-icon trip-reservation__payment-method-icon--${paymentType}`}
            />
        </label>
    )
}

export default PaymentMethod
